import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "list", "option", "input"]

  connect() {
    this.open = false
    this.currentIndex = -1
    this.hide()
    this.onDocumentClick = this.onDocumentClick.bind(this)
    document.addEventListener('click', this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
  }

  toggle(event) {
    event.preventDefault()
    this.open ? this.hide() : this.show()
  }

  show() {
    this.open = true
    this.listTarget.classList.remove('hidden')
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.currentIndex = -1
    this.focusOption(0)
  }

  hide() {
    this.open = false
    if (this.hasListTarget) this.listTarget.classList.add('hidden')
    if (this.hasButtonTarget) this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.currentIndex = -1
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  select(event) {
    event.preventDefault()
    let el = event.currentTarget
    if (!el) return
    const value = el.dataset.value || el.textContent.trim()
    const label = el.textContent.trim()
    if (this.hasInputTarget) this.inputTarget.value = value
    if (this.hasButtonTarget) this.buttonTarget.textContent = label
    // visually mark selected
    this.optionTargets.forEach(o => o.classList.remove('bg-brand_blue-200'))
    el.classList.add('bg-brand_blue-200')
    this.hide()
  }

  keydown(event) {
    if (!this.open && (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === ' ')) {
      event.preventDefault()
      this.show()
      return
    }

    if (!this.open) return
    const max = this.optionTargets.length - 1
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      this.focusOption(Math.min(this.currentIndex + 1, max))
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      this.focusOption(Math.max(this.currentIndex - 1, 0))
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      if (this.currentIndex >= 0) {
        this.optionTargets[this.currentIndex].click()
      }
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.hide()
    }
  }

  focusOption(index) {
    if (index < 0 || index >= this.optionTargets.length) return
    this.currentIndex = index
    const el = this.optionTargets[index]
    el.focus()
  }
}
